window._ = require("lodash");
window.Vue = require("vue").default;
import Vue from "vue";

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");
window.axios.defaults.headers.common = {
    "X-Requested-With": "XMLHttpRequest",
    "X-CSRF-TOKEN": document.head.querySelector('meta[name="csrf-token"]')
        .content,
};
window.axios.defaults.withCredentials = true;

/**
 * Integrate Vue ant design
 */
import "ant-design-vue/dist/antd.min.css";
import Antd, { notification } from "ant-design-vue";
Vue.use(Antd);
notification.config({
    placement: "bottomRight",
});

import "./frontend.scss";

import Clipboard from "v-clipboard";
Vue.use(Clipboard);

/**
 * The following block of code may be used to automatically register
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 */
Vue.component(
    "subscribe-form",
    require("./frontend-components/subscribe-form.vue").default
);
Vue.component(
    "contact-form",
    require("./frontend-components/contact-form.vue").default
);
Vue.component(
    "template-list",
    require("./frontend-components/template-list.vue").default
);
Vue.component(
    "template-download",
    require("./frontend-components/template-download.vue").default
);
Vue.component(
    "template-request-form",
    require("./frontend-components/template-request-form.vue").default
);
Vue.component(
    "similar-templates",
    require("./frontend-components/similar-templates.vue").default
);
Vue.component(
    "share-with-favourite-list",
    require("./frontend-components/share-with-favourite-list.vue").default
);
Vue.component(
    "customer-comments",
    require("./frontend-components/customer-comments.vue").default
);

// Site Alert
Vue.component(
    "site-bar-alert",
    require("./frontend-components/alerts/SiteBarAlert.vue").default
);
Vue.component(
    "site-popup-alert",
    require("./frontend-components/alerts/SitePopUpAlert.vue").default
);

/**
 * Register Global filters
 */
Vue.filter("str_limit", function (value, size = 10) {
    if (!value) return "";
    value = value.toString();

    if (value.length <= size) {
        return value;
    }
    return value.substr(0, size) + "...";
});

Vue.filter("trim", function (value) {
    if (!value) return "";

    return value.trim();
});

const app = new Vue({
    el: "#app",
});
